<template>
  <Avatar
    v-if="imageUrl"
    :image="imageUrl"
    :size="size"
    shape="circle"
    class="avatar-object-fit"
  />
  <Avatar
    v-else
    :label="props.initials"
    :size="size"
    style="color: #000"
    shape="circle"
  />
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { AdminAsset, Asset } from "@/api/model";
import { getAssetThumbnail } from "@/shared/utils/helpers";
import Avatar from "primevue/avatar";

interface Props {
  initials: string;
  size?: "normal" | "large" | "xlarge";
  color?: string;
  asset?: AdminAsset | Asset;
  image?: string;
}
const props = withDefaults(defineProps<Props>(), {
  initials: "",
  size: "normal",
  color: "black",
  asset: undefined,
  image: undefined,
});

const imageUrl = computed(
  () =>
    props.image ||
    (props.asset && getAssetThumbnail(props.asset as AdminAsset)) ||
    props.asset?.file?.cf_url ||
    undefined
);
</script>
